import { render, staticRenderFns } from "./CompareInapiData.vue?vue&type=template&id=63675df5&scoped=true"
import script from "./CompareInapiData.vue?vue&type=script&lang=js"
export * from "./CompareInapiData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63675df5",
  null
  
)

export default component.exports